// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".contactbox__contact{margin-bottom:1.667rem;display:flex;flex-direction:column;align-items:flex-start;font-style:normal;line-height:1.6rem}.contactbox__contact .link{padding-bottom:0}", ""]);
// Exports
module.exports = exports;
